import { render, staticRenderFns } from "./WrittingTemplateComp.vue?vue&type=template&id=23a09a19&scoped=true"
import script from "./WrittingTemplateComp.vue?vue&type=script&lang=js"
export * from "./WrittingTemplateComp.vue?vue&type=script&lang=js"
import style0 from "./WrittingTemplateComp.vue?vue&type=style&index=0&id=23a09a19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a09a19",
  null
  
)

export default component.exports